const reduceCallback = (accumulator, current) => {
	if (accumulator.some(({userId}) => userId === current?.userId)) return accumulator;
	return [...accumulator, {...current}];
};

export default (contacts) => contacts.reduce(reduceCallback, []);
